"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Onboarding = void 0;
const react_1 = __importStar(require("react"));
const controls_1 = require("../controls");
const Dialog_1 = require("../Dialog");
const helpers_1 = require("../helpers");
const Popup_1 = require("../Popup");
const _1 = require(".");
const DEFAULT_TEXTS = {
    start: 'Start',
    skip: 'Skip',
    previous: 'Previous',
    next: 'Next',
    finish: 'Finish',
    dontShowAgain: "Don't show again"
};
const getActions = (dataSelectorId, currentIndex, stepsCount, isCheckedDontShowState, handleDontShowChange, handleStartClick, handleSkipClick, handlePrevClick, handleNextClick, handleFinishClick, uiTexts) => {
    switch (currentIndex) {
        case 0: {
            return (react_1.default.createElement(Dialog_1.DialogActions, { "data-selector-id": `${dataSelectorId}-actions`, distribution: Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.end, secondary: [
                    {
                        render: () => {
                            return (react_1.default.createElement(controls_1.Checkbox, { onChange: handleDontShowChange, checked: isCheckedDontShowState, "data-selector-id": `${dataSelectorId}-checkbox`, "data-checked": isCheckedDontShowState ? true : undefined }, uiTexts.dontShowAgain));
                        }
                    }
                ], primary: [
                    {
                        id: 'start',
                        text: uiTexts.start,
                        onClick: handleStartClick
                    },
                    {
                        id: 'skip',
                        text: uiTexts.skip,
                        view: Dialog_1.ACTION_VIEW.secondary,
                        onClick: handleSkipClick
                    }
                ] }));
        }
        case stepsCount - 1: {
            return (react_1.default.createElement(Dialog_1.DialogActions, { "data-selector-id": `${dataSelectorId}-actions`, distribution: Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.center, primary: [
                    {
                        id: 'prev',
                        text: uiTexts.previous,
                        onClick: handlePrevClick,
                        view: Dialog_1.ACTION_VIEW.alternate
                    },
                    {
                        id: 'finish',
                        text: uiTexts.finish,
                        onClick: handleFinishClick
                    }
                ] }));
        }
        default: {
            return (react_1.default.createElement(Dialog_1.DialogActions, { "data-selector-id": `${dataSelectorId}-actions`, distribution: Dialog_1.DIALOG_ACTIONS_DISTRIBUTION.center, primary: [
                    {
                        id: 'prev',
                        text: uiTexts.previous,
                        onClick: handlePrevClick,
                        view: Dialog_1.ACTION_VIEW.alternate
                    },
                    {
                        id: 'next',
                        text: uiTexts.next,
                        onClick: handleNextClick
                    }
                ] }));
        }
    }
};
exports.Onboarding = (0, helpers_1.createUIElement)('Onboarding', (_a, ref) => {
    var { className, steps, dontShowValue = true, onDontShowChange, onRequestClose, onStart, onSkip, onPrev, onNext, onFinish, width = 'auto', height = 'auto', hasClose = true, texts, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "steps", "dontShowValue", "onDontShowChange", "onRequestClose", "onStart", "onSkip", "onPrev", "onNext", "onFinish", "width", "height", "hasClose", "texts", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const uiTexts = Object.assign(Object.assign({}, DEFAULT_TEXTS), texts);
    const { getValue: getCheckedDontShowState, setValue: setCheckedDontShowState } = (0, helpers_1.useStateValue)(dontShowValue, [dontShowValue]);
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0);
    const dataSelectorId = rest['data-selector-id'] || 'onboarding';
    const decrementCurrentIndex = () => {
        setCurrentIndex(currentIndex - 1);
    };
    const incrementCurrentIndex = () => {
        setCurrentIndex(currentIndex + 1);
    };
    const handleDontShowChange = () => {
        const newIsCheckedDontShowState = !getCheckedDontShowState();
        setCheckedDontShowState(newIsCheckedDontShowState);
        onDontShowChange === null || onDontShowChange === void 0 ? void 0 : onDontShowChange(newIsCheckedDontShowState);
    };
    const handleStartClick = () => {
        incrementCurrentIndex();
        onStart === null || onStart === void 0 ? void 0 : onStart();
    };
    const handleSkipClick = () => {
        onSkip === null || onSkip === void 0 ? void 0 : onSkip();
        onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
    };
    const handleFinishClick = () => {
        onFinish === null || onFinish === void 0 ? void 0 : onFinish();
        onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
    };
    const handlePrevClick = () => {
        decrementCurrentIndex();
        onPrev === null || onPrev === void 0 ? void 0 : onPrev(currentIndex - 1);
    };
    const handleNextClick = () => {
        incrementCurrentIndex();
        onNext === null || onNext === void 0 ? void 0 : onNext(currentIndex + 1);
    };
    const actions = getActions(dataSelectorId, currentIndex, steps.length, getCheckedDontShowState(), handleDontShowChange, handleStartClick, handleSkipClick, handlePrevClick, handleNextClick, handleFinishClick, uiTexts);
    return (react_1.default.createElement(Popup_1.Popup, Object.assign({}, rest, { "data-selector-id": dataSelectorId, className: `vm-Onboarding ${className}`, body: react_1.default.createElement(_1.OnboardingBody, { "data-selector-id": `${dataSelectorId}-body`, header: steps[currentIndex].header, content: steps[currentIndex].content, image: steps[currentIndex].image, totalSteps: currentIndex > 0 ? steps.length : undefined, currentIndex: currentIndex > 0 ? currentIndex : undefined }), actions: actions, onRequestClose: onRequestClose, width: width, height: height, canClose: hasClose, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
//# sourceMappingURL=Onboarding.js.map